import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue,orderByChild,startAt,endAt} from "firebase/database";

function toTimestamp(strDate){
  var datum = Date.parse(strDate);
  return datum;
}

const useObtenerViajesDescarga = () => {
    
    const [viajes, cambiarViajes] = useState([]);
    

    useEffect( () => {
        cambiarViajes([]);
        const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('fecha_hora_programada'),startAt(toTimestamp('2023/09/30')),endAt(toTimestamp('2023/11/01')));
        console.log("llama base de viajes");
        return onValue(consulta, (snapshot) => {
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
        //   if (viajes.length === 0) { 
            cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
        /*    } else {
                if(viajes.id.includes(childKey)){
                    console.log("Ya está presente");
                  }else{
                    cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
                    console.log("Se agrega a viajes");
            }
//            cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
            }*/
            });
    },{
        onlyOnce: true
      }
       
    );            
    }, []);
    return (viajes);
}


export default useObtenerViajesDescarga;